/**
 * Whether a usable Clerk publishable key is configured.
 *
 * When the key is absent or still a setup placeholder ("FILL_IN_..."),
 * mounting <ClerkProvider> throws and takes the whole app down — including
 * public pages (map, vetting demo) that need no auth at all. Consumers use
 * this flag to fall back to a signed-out, no-auth mode instead.
 */
export const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY ?? '';

export const isClerkConfigured = /^pk_(test|live)_/.test(CLERK_PUBLISHABLE_KEY);
